import { Category } from "@/entities";
import { ICatalogRepository } from "./catalog.types";
import axios from "axios"
import { Metadata } from "@/entities/metadata/metadata";

export class CatalogAPIRepository implements ICatalogRepository {
    async getCatalog(): Promise<Category> {
        const response = await axios.get('https://catalog-tree-for-front-end.s3.ap-southeast-1.amazonaws.com/catalog-tree')
        console.log(response.data)
        if (response.status == 200) {
            return new Category(response.data);
        } else {
            return new Category({
                groupId: -1,
                groupName: "",
                metadata: new Metadata({ show: false }),
                productList: []
            }
            );
        }
    }

}